import React from 'react';
import { SquareButton, Variant } from './SquareButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { Colors } from '@app/theme';

interface Props {
  to?: string;
  color: Colors;
  variant?: Variant;
  className?: string;
  overGray?: boolean;
  icon?: string;
}

export const BackButton = ({ to: propsTo, ...rest }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  let to = propsTo;
  if (!to) {
    if (!(location.state as any)?.allowBack) {
      to = '/';
    }
  }

  const props = to
    ? {
        to,
        ...rest,
      }
    : {
        onClick: () => navigate(-1),
        ...rest,
      };

  return <SquareButton icon="ri-arrow-left-line" {...props} />;
};
